<script>
  import { ChevronDown } from 'lucide-svelte'
  import { cn } from '@lib/utils'

  let { open = $bindable(false), class: className = '', ...restProps } = $props()
</script>

<ChevronDown size={12} class={cn('transition-transform duration-200', open ? 'rotate-180' : '', className)} {...restProps} />